export default "__VITE_ASSET__BWKTYxL8__"